export const formattedSize = (file) => {
  if (0 === file?.size) {
    return '0 Bytes';
  }

  const i = parseInt(Math.floor(Math.log(file?.size) / Math.log(1024)));

  return `${Math.round(file?.size / Math.pow(1024, i))} ${['Bytes', 'KB', 'MB', 'GB', 'TB'][i]}`;
};
